module.exports = __webpack_public_path__ + "img/paper_purple.c151639f.svg";